'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevrondown from '@common/__generated__/icon/SvgChevrondown';
import { Button } from '@common/components';
import { cn } from '@core/utils';
import dayjs from 'dayjs';
import useEmblaCarousel from 'embla-carousel-react';
import { useState } from 'react';
import { Image } from '@/components/client';
import { Rating } from '../Rating';
interface ReviewCardProps {
  rating: number;
  createdAt: string;
  productName: string;
  contents: string;
  reviewer: string;
  imageUrlList: string[];
  answer?: string;
  answerAt?: string;
  /** 추가 액션 요소 (드롭다운 메뉴 등), 오른쪽 상단에 렌더링 */
  actions?: React.ReactNode;
  /** 이미지 클릭 콜백 */
  onImageClick?: () => void;
}
export const ReviewCard = t0 => {
  const $ = _c(39);
  const {
    rating,
    createdAt,
    productName,
    contents: t1,
    reviewer,
    imageUrlList: t2,
    answer: t3,
    answerAt,
    actions,
    onImageClick
  } = t0;
  const contents = t1 === undefined ? "" : t1;
  let t4;
  if ($[0] !== t2) {
    t4 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const imageUrlList = t4;
  const answer = t3 === undefined ? "" : t3;
  const [isExpanded, setIsExpanded] = useState(false);
  const [isAnswerExpanded, setIsAnswerExpanded] = useState(false);
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      align: "start",
      dragFree: true,
      containScroll: "trimSnaps"
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const [emblaRef] = useEmblaCarousel(t5);
  let t6;
  if ($[3] !== actions) {
    t6 = actions ? <div className="absolute right-20 top-20">{actions}</div> : null;
    $[3] = actions;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== rating) {
    t7 = <Rating value={rating} size={16} className="mb-8" />;
    $[5] = rating;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== reviewer) {
    t8 = <span className="text-Gray-550 typo-caption1">{reviewer}</span>;
    $[7] = reviewer;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="h-10 border-l-1 border-Gray-300" />;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== createdAt) {
    t10 = dayjs(createdAt).format("YYYY.MM.DD");
    $[10] = createdAt;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10) {
    t11 = <span className="text-Gray-550 typo-caption1">{t10}</span>;
    $[12] = t10;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t11 || $[15] !== t8) {
    t12 = <div className="mb-6 flex items-center gap-8">{t8}{t9}{t11}</div>;
    $[14] = t11;
    $[15] = t8;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== productName) {
    t13 = <p className="mb-16 font-400 text-Gray-600 typo-body4">{productName}</p>;
    $[17] = productName;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== emblaRef || $[20] !== imageUrlList || $[21] !== onImageClick || $[22] !== productName) {
    t14 = imageUrlList.length > 0 && <div className="mb-16"><div className="relative w-full overflow-hidden" ref={emblaRef}><div className="flex gap-8">{imageUrlList.map((url, index) => <div key={index} className={cn("w-auto flex-[0_0_auto]", onImageClick && "cursor-pointer")} onClick={onImageClick}><Image src={url} alt={`${productName}-${index + 1}`} width={128} height={128} className="block aspect-square rounded-large object-cover" /></div>)}</div></div></div>;
    $[19] = emblaRef;
    $[20] = imageUrlList;
    $[21] = onImageClick;
    $[22] = productName;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== contents || $[25] !== isExpanded) {
    t15 = contents.length > 100 ? <p className="whitespace-pre-line font-500 text-Gray-800 typo-body3">{isExpanded ? contents : `${contents.slice(0, 100)}...`}{!isExpanded && <span role="button" tabIndex={0} onClick={e => {
        e.stopPropagation();
        setIsExpanded(true);
      }} onKeyDown={e_0 => {
        if (e_0.key === "Enter" || e_0.key === " ") {
          e_0.preventDefault();
          e_0.stopPropagation();
          setIsExpanded(true);
        }
      }} className="inline-block cursor-pointer whitespace-nowrap px-4 font-600 text-Gray-550 typo-body3">더보기</span>}</p> : <p className="whitespace-pre-line font-500 text-Gray-800 typo-body3">{contents}</p>;
    $[24] = contents;
    $[25] = isExpanded;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== answer || $[28] !== answerAt || $[29] !== isAnswerExpanded) {
    t16 = answer ? <div className="mt-16 flex w-full flex-col rounded-medium bg-Gray-25 p-20"><div className="flex items-center justify-between pb-4"><p className="font-600 text-Gray-700 typo-body4">판매자</p>{answerAt ? <p className="font-400 text-Gray-550 typo-caption1">{dayjs(answerAt).format("YYYY.MM.DD")}</p> : null}</div><p className="whitespace-pre-line pb-8 font-400 text-Gray-700 typo-body4">{answer.length > AnswerExpandedPoint ? <>{isAnswerExpanded ? answer : `${answer.slice(0, AnswerExpandedPoint)}...`}</> : answer}</p>{answer.length > AnswerExpandedPoint && <Button className="mt-8 size-fit p-0" theme="sub-text" asChild={true}><div className="flex cursor-pointer items-center gap-4" onClick={e_1 => {
          e_1.stopPropagation();
          setIsAnswerExpanded(_temp);
        }}><p className="font-600 text-Gray-550 typo-caption1">{isAnswerExpanded ? "\uC811\uAE30" : "\uB354\uBCF4\uAE30"}</p><SvgChevrondown className={cn("size-12 text-Gray-550 transition-transform duration-300", {
            "-rotate-180": isAnswerExpanded
          })} /></div></Button>}</div> : null;
    $[27] = answer;
    $[28] = answerAt;
    $[29] = isAnswerExpanded;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  let t17;
  if ($[31] !== t12 || $[32] !== t13 || $[33] !== t14 || $[34] !== t15 || $[35] !== t16 || $[36] !== t6 || $[37] !== t7) {
    t17 = <div className="relative border-t-1 border-Gray-200 p-20 text-left first:border-t-0">{t6}{t7}{t12}{t13}{t14}{t15}{t16}</div>;
    $[31] = t12;
    $[32] = t13;
    $[33] = t14;
    $[34] = t15;
    $[35] = t16;
    $[36] = t6;
    $[37] = t7;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  return t17;
};
const AnswerExpandedPoint = 60;
function _temp(prev) {
  return !prev;
}